import React from 'react';
import { Grid } from 'lucide-react';

const sectors = [
  { id: 'sec-it', name: 'IT', change: 1.24, stocks: 12 },
  { id: 'sec-banking', name: 'Banking', change: 0.87, stocks: 18 },
  { id: 'sec-pharma', name: 'Pharma', change: -1.28, stocks: 15 },
  { id: 'sec-auto', name: 'Auto', change: 1.53, stocks: 8 },
  { id: 'sec-fmcg', name: 'FMCG', change: -0.34, stocks: 10 },
  { id: 'sec-metal', name: 'Metal', change: -1.44, stocks: 9 },
  { id: 'sec-energy', name: 'Energy', change: 0.72, stocks: 7 },
  { id: 'sec-realty', name: 'Realty', change: 2.18, stocks: 6 },
  { id: 'sec-infra', name: 'Infra', change: 0.45, stocks: 11 },
  { id: 'sec-media', name: 'Media', change: -0.89, stocks: 5 },
  { id: 'sec-telecom', name: 'Telecom', change: 0.33, stocks: 4 },
  { id: 'sec-psu', name: 'PSU', change: 1.02, stocks: 14 },
];

function getHeatColor(change: number): string {
  if (change >= 2) return 'bg-positive text-primary-foreground';
  if (change >= 1) return 'bg-positive/60 text-primary-foreground';
  if (change >= 0.3) return 'bg-positive/30 text-positive';
  if (change >= 0) return 'bg-positive/15 text-positive';
  if (change >= -0.5) return 'bg-negative/15 text-negative';
  if (change >= -1) return 'bg-negative/30 text-negative';
  if (change >= -1.5) return 'bg-negative/60 text-negative';
  return 'bg-negative text-foreground';
}

export default function SectorHeatmap() {
  return (
    <div className="card-elevated p-4 h-full">
      <div className="flex items-center gap-2 mb-3">
        <Grid size={14} className="text-muted-foreground" />
        <h2 className="text-sm font-semibold text-foreground">Sector Heatmap</h2>
      </div>
      <div className="grid grid-cols-3 gap-1.5">
        {sectors.map((s) => (
          <div
            key={s.id}
            className={`rounded-lg p-2 text-center cursor-pointer hover:opacity-90 transition-opacity ${getHeatColor(s.change)}`}
          >
            <p className="text-2xs font-bold">{s.name}</p>
            <p className="text-xs font-bold font-tabular mt-0.5">
              {s.change >= 0 ? '+' : ''}{s.change.toFixed(2)}%
            </p>
            <p className="text-2xs opacity-70">{s.stocks} stocks</p>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mt-3 pt-2 border-t border-border">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-sm bg-negative" />
          <span className="text-2xs text-muted-foreground">Loss</span>
        </div>
        <div className="flex gap-0.5">
          {[-2, -1, 0, 1, 2].map((v) => (
            <div key={`heat-legend-${v}`} className={`w-4 h-2 rounded-sm ${getHeatColor(v).split(' ')[0]}`} />
          ))}
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-sm bg-positive" />
          <span className="text-2xs text-muted-foreground">Gain</span>
        </div>
      </div>
    </div>
  );
}